Vue.component('v-register-list', {
  data: function () {
    return {
      pageNumb: 10,
      table: null,
      loading: false,
      timeOut: 0,
      page: 1,
      paginationPages: 0,
      list: [],
      name: '',
      data: 1
    }
  },
  mounted: function () {
    $(document).keydown(function (e) {
      if (e.keyCode == 13)
        return false
    });
    this.start('spec')
  },
  methods: {
    start(table) {
      this.table = table
      this.getList({page_max: this.pageNumb, table: this.table})
    },
    getList(send, concat) {
      $.ajax({
        type: "POST",
        url: "ajax.php?act=getRegisterList",
        data: send,
        beforeSend: () => {
          this.loading = true
        },
        success: (data) => {
          this.loading = false
          this.list = concat ? this.list.concat(data.data.items) : data.data.items
          this.paginationPages = Math.ceil(data.data.num / this.pageNumb)
        }
      });
    },
    loadMore() {
      this.page = this.page + 1
      this.getList({
        name: this.name,
        page_max: this.pageNumb,
        table: this.table,
        page: this.page
      }, true);
    },
    inputKeyup(e) {
      var name = e.target.value;
      if (name.length < 3 && e.keyCode !== 8 && e.keyCode !== 46)
        return false;
      this.name = name


      clearTimeout(this.timeOut);
      var self = this;
      this.timeOut = setTimeout(() => {
        self.page = 1
        self.getList({
          name: this.name,
          page_max: self.pageNumb,
          table: self.table
        });
      }, 2000);
    }
  }
})
